

import { Vue} from "vue-property-decorator"

export default class TirscriptTableHeaderComponent extends Vue {

}
